import React from 'react'
import { Grid, SelectChangeEvent } from '@mui/material'

import { ButtonResetTableFilters, DateRange } from '@/components'
import { B2CTypeTable } from '@/types.ts'
import { useB2CState } from '@/stores/slices/b2c-slice'
import { b2cActions, B2CTableState } from '@/stores/slices/b2c-slice/b2c-slice.ts'
import { useAppDispatch } from '@/stores/hooks.ts'

import { B2CPaymentsTypeSelect } from './b2c-payments-type-select.tsx'
import { B2CToggleFilter } from './b2c-toggle-filter'

const resettableKeyFilters: (keyof B2CTableState)[] = [
  'dateTo',
  'dateFrom',
  'b2cState',
  'b2cRegistryState',
  'b2cPaymentsType',
]

export const B2CFilters = (): React.ReactElement => {
  const { b2cPaymentsType: state, b2cType, dateRange, resettableStateFilters } = useB2CState(resettableKeyFilters)
  const dispatch = useAppDispatch()

  const handleStatusChange = (event: SelectChangeEvent) => {
    dispatch(b2cActions.setFilter({ filterKey: 'b2cPaymentsType', filterValue: event.target.value }))
  }

  const selectValue = state || 'ALL'

  const handleDateChange = (value: [string?, string?]) => {
    dispatch(b2cActions.setFilter({ filterKey: 'dateFrom', filterValue: value[0] }))
    dispatch(b2cActions.setFilter({ filterKey: 'dateTo', filterValue: value[1] }))
  }

  const columnsCount = b2cType !== B2CTypeTable.REGISTRIES ? 15 : 12

  const resetFilters = () => dispatch(b2cActions.resetFilters(resettableKeyFilters))

  return (
    <Grid container spacing={2} flexDirection="row" columns={columnsCount}>
      {b2cType !== B2CTypeTable.REGISTRIES && (
        <Grid item xs={columnsCount} lg={3}>
          <B2CPaymentsTypeSelect value={selectValue} onChange={handleStatusChange} />
        </Grid>
      )}
      <Grid item xs={columnsCount} lg={3}>
        <B2CToggleFilter />
      </Grid>
      <Grid item xs={columnsCount} lg={6}>
        <DateRange initialRange={dateRange} onChange={handleDateChange} />
      </Grid>
      <Grid item xs={columnsCount} lg={3}>
        <ButtonResetTableFilters stateFilters={resettableStateFilters} onResetFilters={resetFilters} />
      </Grid>
    </Grid>
  )
}
